import graphql from "babel-plugin-relay/macro";

export default graphql`
  query getEventQuery($id: ID!) {
    hyevent(id: $id) {
      approverName
      inviteScheduledAt
      approvedAt
      disapprovedAt
      id
      title
      maxNoOfGuests
      additionalGuestAllowed
      maxAdditionalGuests
      ctaText
      disapproveReason
      messageTitle
      message
      address
      placeName
      status
      propertyId
      startAt
      endAt
      publishAt
      cancelReason
      rsvpedCount
      landingPageHtml
      invitedGroups
      confirmPageHtml
      confirmSmsBody
      flyerHtml
      waitlistedPageHtml
      cancelRsvpPageHtml
      removeFromWaitlistPageHtml
      inviteEmailCampaignId
      campaignTested
      image{
        id
        fileType
        fileSize
        fileUrl
        dimension
        thumbnailUrl
      }
      document{
        createdAt
        dimension
        fileSize
        fileType
        fileUrl
        id
        name
        thumbnailUrl
      }
      eventType
      zoomLink
      meetingId
      passcode
      smsEnabled
      displayTime
      leadFields
      rsvpFormHeader
      thankYouEmailHour
      enableThankYouEmail
      enableCancelEmail      
      enableInviteEmail
      enableMorningReminderEmail
      enableNightReminderEmail
      enableRescheduleEmail
      enableRsvpCancelledEmail
      enableRsvpedEmail
      enableWaitlistOpeningEmail
      enableWaitlistedEmail
      emailList
      recurringEventType
      repeatType
      recurrenceType
      recurrenceEndDate
      recurringDaysList
    }
  }
`;
